import 'bootstrap/dist/css/bootstrap.min.css';
import {Route, Routes, Navigate} from "react-router-dom";

import NavbarMain from "./Components/Navbar/Navbar";
import Homepage from "./Pages/Homepage"
import Projects from './Pages/Projects';
import About from "./Pages/AboutMe"
import Coursework from './Pages/Coursework';


import Footer from "./Components/Footer/Footer"

function App() {

  return (

    <div>

      <header>
        <NavbarMain /> 
      </header>

      <main>

        {/* React-router that renders all different pages */}
        <Routes>
          <Route path="/*" element={<Navigate replace to="homepage" />} />
          <Route path="/homepage" element={<Homepage />} /> 
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/coursework" element = {<Coursework />} />
        </Routes>
      </main>
      
      {/* Footer */}
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default App;
